/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "D4FE82C8-EE88-4C6E-98D4-D6E6E06EF37A",
  "sitecoreApiHost": "https://partneracademy.lorealdermatologicalbeauty.fr",
  "jssAppName": "formationcaf",
  "defaultLanguage": "fr-FR",
  "graphQLEndpointPath": "/api/formationcaf",
  "graphQLEndpoint": "https://partneracademy.lorealdermatologicalbeauty.fr/api/formationcaf?sc_apikey=D4FE82C8-EE88-4C6E-98D4-D6E6E06EF37A"
};